import api from './api';

const grantedFlag = value => value === true || value === 1 || value === '1';
const amount = value => value == null || value === '' || !Number.isFinite(Number(value)) || Number(value) < 0 ? null : Number(value);

export async function unlockQuizWithCoins(quizId) {
  if (!Number.isSafeInteger(Number(quizId)) || Number(quizId) <= 0) throw new Error('Select a valid quiz.');
  const response = await api.post('/quiz/unlock-with-coins', { quiz_id: Number(quizId) });
  const meta = response?.data;
  if (!meta || meta.error || (meta.code != null && Number(meta.code) !== 200)) throw new Error(meta?.message || 'Unable to unlock quiz.');
  const data = meta.dataset?.data;
  if (!data || typeof data !== 'object' || Array.isArray(data) ||
      (!Object.prototype.hasOwnProperty.call(data, 'access_granted') && !Object.prototype.hasOwnProperty.call(data, 'already_unlocked'))) {
    throw new Error('The server did not confirm quiz access. Please try again.');
  }
  const granted = grantedFlag(data.access_granted) || grantedFlag(data.already_unlocked);
  const balance = amount(data.ad_coin_balance ?? data.coin_unlock_balance);
  const eligibleBalance = amount(data.coin_unlock_balance ?? data.ad_coin_balance);
  const cost = amount(data.required_coins ?? data.coin_unlock_cost);
  if (!granted && (balance === null || cost === null)) throw new Error('Unable to read the quiz coin balance. Please try again.');
  return { granted, balance, eligibleBalance, cost, remaining: Math.max(0, (cost ?? 0) - (eligibleBalance ?? 0)), coinsSpent: amount(data.coins_spent), raw: data };
}
